import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { FooterMedium } from "../../../components/FooterMedium";

import {
  Screen1,
  Marathon,
  Decide,
  Gifts,
  Program,
  Timetable,
  ResultsAfter,
  ResultsStudents,
  RevsText,
  Speakers,
  Neuro,
  RevsVids,
  Graduate,
  Smi,
  Reg
} from "../../../components/LandingTemplates/marafon_motivacii_i_obuchenija_detej_v2";

const TITLE = 'Марафон мотивации и обучения детей';
const DESCRIPTION = 'Марафон мотивации и обучения детей - бесплатный 5-дневный марафон. Ребенок научится самостоятельно выполнять домашние задания! | Центр образовательных технологий Advance';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = (
  {
    widgetFree=<GetCourseWidget hash={'2b439a521741c0a3417a85d54920da8ccf2780dc'} id={'1220185'}/>,
    widgetFreeHorizontal=<GetCourseWidget hash={'7f7c36a4dba41392c176cdf45c9e523495d9017c'} id={'1220187'}/>,
    widgetFreeGrid=<GetCourseWidget hash={'2b6472f41e98110255aef6e6a8ed4aa6d60578a8'} id={'1220186'}/>,
  }) => {
  return <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1 id={'mndu_v2'} widgetFree={widgetFree} />
      <Marathon/>
      <Decide/>
      <Gifts widgetFree={widgetFreeHorizontal}/>
      <Program/>
      <Timetable id={'mndu_v2'} widgetFree={widgetFreeGrid}/>
      <ResultsAfter widgetFree={widgetFreeHorizontal}/>
      <ResultsStudents/>
      <RevsText/>
      <Speakers/>
      <Neuro widgetFree={widgetFree}/>
      <RevsVids/>
      <Graduate/>
      <Smi/>
      <Reg id={'mndu_v2'} widgetFree={widgetFree}/>
    </main>

    <FooterMedium/>

  </DefaultLayout>
};
export default Page;
